import { AuthGuard, configurationAuthScope, CrudOp } from "@org-avp/avp-avengers-ui-shared-auth";
import { useRequiredProjectParam, useRequiredSubprojectParam } from "@org-avp/avp-avengers-ui-shared-store";
import { importView } from "@org-avp/avp-avengers-ui-shared-utils";
import { FC, lazy, Suspense } from "react";

export const ConfigurationManagerView: FC = () => {
  const projectId = useRequiredProjectParam("projectId");
  const subprojectId = useRequiredSubprojectParam("subprojectId");
  const brand = useRequiredProjectParam("brand");
  const modelYear = parseInt(useRequiredSubprojectParam("modelYear"));
  const mbvKeys = useRequiredSubprojectParam("mbvKeys", parseArrayAndSort);
  const idmmId = useRequiredSubprojectParam("tmmId");
  return (
    <AuthGuard authScope={configurationAuthScope} crudOp={CrudOp.READ} brand={brand}>
      <Suspense>
        <LazyConfigurationManagerView
          projectId={projectId}
          subprojectId={subprojectId}
          brand={brand}
          modelYear={modelYear}
          mbvKeys={mbvKeys}
          idmmId={idmmId}
        />
      </Suspense>
    </AuthGuard>
  );
};

const LazyConfigurationManagerView = lazy(importView(
  () => import("../components/ConfigurationTabView"),
  (it) => it.ConfigurationTabView,
));

const parseArrayAndSort = (param: string): string[] => {
  return param.split(",").sort();
};
